import PageLayout from '@/common/components/page-layout';
import Spacer from '@/common/components/spacer';
import { Link } from 'react-router';
import type { MetaFunction } from 'react-router';
import { buildPageMeta } from '@/util-react-router/build-page-meta';

export const meta: MetaFunction = () => {
  return buildPageMeta({
    title: 'Terms of Use',
    description:
      'Read our terms of use policy for Flexcar. Be up to date on all of our latest policy information.',
  });
};

export default function TermsOfUse() {
  return (
    <PageLayout>
      <h1>Legal</h1>
      <Spacer variant="height8" />

      <div>
        Please read carefully the following legal agreement before using this website. By
        using this website, you signify your assent to these terms of use. If you do not
        agree to these terms of use, please disconnect from and do not use this website.
      </div>
      <Spacer variant="height16" />

      <h2>Reservation of rights</h2>
      <Spacer variant="height8" />

      <div>
        All rights, titles, and interests in and to this website are owned by Flexcar LLC
        The website is protected by copyright law. All trademarks, service marks, and
        trade names are proprietary to Flexcar LLC, including the Flexcar name and logo.
        In particular, the Flexcar logo and the word &quot;Flexcar&quot; are registered
        trademarks. None of the items mentioned herein may be used without the express
        written consent of Flexcar. All rights not expressly licensed hereunder are
        reserved by Flexcar LLC.
      </div>
      <Spacer variant="height16" />

      <h2>Exceptions</h2>
      <Spacer variant="height8" />

      <div>
        The above policies may be superseded by requirements or obligations imposed by
        statute, regulation, or legal process. If you have any questions or concerns
        regarding our usage agreement, please email us at{' '}
        <Link className="link-body font-bold" to="mailto:legal@flexcar.com">
          legal@flexcar.com
        </Link>
        .
      </div>
      <Spacer variant="height16" />

      <h2>Copyright Notice</h2>
      <Spacer variant="height8" />

      <div>
        Automotive Images, Copyright [2000 – 2020] izmo, Inc. All Rights Reserved. The
        automotive images contained herein are owned by izmo, Inc. and are protected under
        United States and international copyright law. Access to and use of these images
        is restricted by terms and conditions of a separate license agreement. Any
        unauthorized use, reproduction, distribution, recording or modification of these
        images is strictly prohibited.
      </div>
      <Spacer variant="height16" />
    </PageLayout>
  );
}
